import { ProcessoCadastro } from "./processo-cadastro";

export interface ProcessoPreCadastroProduto {
  NCODIGO: number;
  NCODIGOPROCESSOCADASTRO: number;
  NB1EMIN: number;
  NB1EMAX: number;
  CB1COD: string;
  CB1DESC: string;
  CB1TIPO: string;
  CB1UM: string;
  CB1SEGUM: string;
  NB1CONV: number;
  CB1MRP: string;
  CB1GRUPO: string;
  CB1XTPPRD: string;
  CB1XFAM: string;
  CB1CONTA: string;
  CB1XCTACUS: string;
  CB1XCTADEA: string;
  CB1XCTADEC: string;
  CB1POSIPI: string;
  CB1TE: string;
  CB1LOCPAD: string;
  CB1XTPSPED: string;

  CSETOR: string;
  CUSOAPLICACAO: string;
  CLOCALUSO: string;
  CB1XDESCL: string;
  CB1XPDM: string;
}

export const defaultProcessoPreCadastroProduto = (): ProcessoPreCadastroProduto => {
  return {
    NCODIGO: 0,
    NCODIGOPROCESSOCADASTRO: 0,
    NB1EMIN: 0,
    NB1EMAX: 0,
    CB1COD: '',
    CB1DESC: '',
    CB1TIPO: '',
    CB1UM: '',
    CB1SEGUM: '',
    NB1CONV: 0,
    CB1MRP: '',
    CB1GRUPO: '',
    CB1XTPPRD: '5',
    CB1XFAM: '',
    CB1CONTA: '',
    CB1XCTACUS: '',
    CB1XCTADEA: '',
    CB1XCTADEC: '',
    CB1POSIPI: '',
    CB1TE: '',
    CB1LOCPAD: '',
    CB1XTPSPED: '',
    CSETOR: '',
    CUSOAPLICACAO: '',
    CLOCALUSO: '',
    CB1XDESCL: '',
    CB1XPDM: '',
  };
};

export interface ProcessoPreCadastroProdutoListaItem {
  NPROCESSOCODIGO: number;
  NCODIGO: number;
  CSTATUS: string;
  CURGENTE: string;
  CB1COD: string;
  CB1DESC: string;
  CUSRID: string;
  CUSRNOME: string;
  DINCLUSAO: Date | undefined;
  DFINALIZACAO: Date | undefined;
}

export const defaultProcessoPreCadastroProdutoListaItem = (): ProcessoPreCadastroProdutoListaItem => {
  return {
    NPROCESSOCODIGO: 0,
    NCODIGO: 0,
    CSTATUS: '',
    CURGENTE: '',
    CB1COD: '',
    CB1DESC: '',
    CUSRID: '',
    CUSRNOME: '',
    DINCLUSAO: undefined,
    DFINALIZACAO: undefined,
  };
};

export interface ProcessoPreCadastroProdutoLista {
  items: Array<ProcessoPreCadastroProdutoListaItem>;
  hasNext: boolean;
}

export const defaultProcessoCadastroDtoList = (): ProcessoPreCadastroProdutoLista => {
  return {
    items: [],
    hasNext: false,
  };
};

export interface ProcessoPreCadastroProdutoDto {
  PRODUTO: ProcessoPreCadastroProduto;
  CHISTORICO: string;
  CDECISAO: string;
  CURGENTE: string;
  CARQUIVOSCHAVE: string;
}
